import * as React from "react"
import { useTranslation } from "react-i18next"

import { useStatefulFieldRemount } from "Catalog/shared/components/StatefulFieldRemountContext"
import { useUIPreferences } from "Catalog/shared/components/UIPreferencesContext"
import useEditor from "shared/hooks/useEditor"
import { IProduct } from "shared/hubrise/models"
import { isMultiSku } from "shared/hubrise/utils/Product"

import FoldableSection from "../FoldableSection"

import SkuTable from "./SkuTable"
import { Checkbox, SkuType, StyledSkus } from "./Styles"

interface SkusProps {
  product: IProduct
}

const Skus = ({ product }: SkusProps): JSX.Element => {
  const { t } = useTranslation()
  const { editor } = useEditor()
  const { remount } = useStatefulFieldRemount()
  const { skusExpanded, setSkusExpanded } = useUIPreferences()

  const [isMulti, setIsMulti] = React.useState<boolean>(isMultiSku(product))
  const [hashAfterChangeToMonosku, setHashAfterChangeToMonosku] = React.useState<string | null>(null)

  const handleChange = (isMultiSku: boolean): void => {
    setIsMulti(isMultiSku)

    if (!isMultiSku) {
      editor.product.changeToMonosku(product)
    } else if (editor.hash === hashAfterChangeToMonosku) {
      // Undo the last edit to restore the previous skus. Only possible if no other edit has been made in between.
      editor.undo()
      remount()
    }

    setHashAfterChangeToMonosku(isMultiSku ? null : editor.hash)
  }

  return (
    <FoldableSection
      title={t("product.skus.title")}
      expanded={skusExpanded}
      onToggle={() => setSkusExpanded(!skusExpanded)}
    >
      <StyledSkus>
        <SkuType>
          <Checkbox name="isMulti" withMargin text={t("product.skus.multi")} value={isMulti} onChange={handleChange} />
        </SkuType>

        <SkuTable product={product} isMultiSku={isMulti} />
      </StyledSkus>
    </FoldableSection>
  )
}

export default Skus
